<template>
  <div class="account-setting">
    <!-- <Navbar title="设置"></Navbar> -->
    <div class="menu" v-if="codeList.length > 0 ? true : false">
      <div class="list" v-for="(item, index) in codeList" :key="index">
        <span>物流码</span>
        <span>{{ item }}</span>
        <van-icon name="close" size="1.3rem" @click="deleteList(index)" />
      </div>
      <div class="add" @click="show = true">
        <van-icon name="add" size="1.3rem" color="#1c86dc" />
        <span style="margin-left: 0.5rem">手动输入</span>
      </div>
    </div>
    <div class="menu" v-else>
      <van-empty description="请扫物流码或手动输入" />
      <div class="add" @click="show = true">
        <van-icon name="add" size="1.3rem" color="#1c86dc" />
        <span style="margin-left: 0.5rem">手动输入</span>
      </div>
    </div>
    <div class="button">
      <van-button
        icon="scan"
        type="primary"
        size="large"
        round
        color="#23b53b"
        style="width: 65%; font-size: 1.3rem"
        @click="onClick"
        >扫码添加</van-button
      >
      <van-button
        type="primary"
        size="large"
        round
        color="#1c86dc"
        style="width: 65%; font-size: 1.3rem; margin-top: 1rem"
        @click="onSubmit"
        >下一步</van-button
      >
    </div>
    <van-dialog
      v-model="show"
      title="手动输入"
      show-cancel-button
      @confirm="confirm"
    >
      <van-field
        v-model="value"
        label="物流码"
        type="number"
        maxlength="16"
        placeholder="请输入物流码"
        :clearable="true"
        label-width="50px"
        style="width: 85%; margin: 0 auto"
      />
    </van-dialog>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import { Dialog } from "vant";
import { verify } from "@/api/exwarehouse";

export default {
  data() {
    return {
      codeList: [],
      show: false,
      value: "",
    };
  },
  mounted() {
    if (
      JSON.parse(localStorage.getItem("codes")) != null &&
      JSON.parse(localStorage.getItem("codes")).length != 0
    ) {
      this.codeList = JSON.parse(localStorage.getItem("codes"));
    }
    // this.verifyCode(6955906447120); 测试使用
  },
  methods: {
    // 校验物流码
    verifyCode(code) {
      if (!this.codeList.includes(code)) {
        verify(code)
          .then((res) => {
            // console.log("校验物流码: ", res);
            if (res.code == 0) {
              // 判断是否为箱码
              if (res.result.items.length != 0) {
                if (res.result.boxCode) {
                  res.result.items.map((date) => {
                    if (!this.codeList.includes(date)) {
                      this.codeList.unshift(date);
                    } else {
                      this.$toast("物流码" + date + "已重复!");
                    }
                  });
                } else {
                  this.codeList.unshift(res.result.items[0]);
                }
              } else {
                this.$toast("已出库!");
              }
              localStorage.setItem("codes", JSON.stringify(this.codeList));
            } else {
              this.$toast(res.message);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        Dialog.alert({
          title: "物流码重复",
          message: "已添加过此物流码,请重新添加",
        }).then(() => {
          // on close
        });
      }
    },
    deleteList(index) {
      this.codeList.splice(index, 1);
      localStorage.setItem("codes", JSON.stringify(this.codeList));
    },
    onClick() {
      let that = this;
      wx.checkJsApi({
        jsApiList: ["scanQRCode"], // 需要检测的JS接口列表，所有JS接口列表见附录2,
        success: function () {
          wx.scanQRCode({
            needResult: 1,
            scanType: ["barCode"],
            success: function (res) {
              const code = res.resultStr.slice(
                res.resultStr.indexOf(",") + 1,
                res.resultStr.length
              );
              if (code.slice(0, 2) == "59") {
                that.verifyCode(code);
              } else if (code.slice(0, 2) == "69") {
                that.verifyCode(code);
              } else if (code.slice(0, 3) == "888") {
                that.verifyCode(code);
              } else if (code.slice(0, 3) == "559") {
                that.verifyCode(code);
              } else if (code.slice(0, 2) == "79") {
                that.verifyCode(code);
              } else if (code.slice(0, 4) == "http") {
                that.$toast("请扫条形码!");
              }
            },
          });
        },
        fail: function () {
          Dialog.confirm({
            title: "温馨提示",
            message: "当前微信版本不支持扫码,请升级微信后尝试",
          });
        },
      });
    },
    // 手动输入提交
    confirm() {
      if (this.value != "") {
        this.verifyCode(this.value);
      } else {
        this.$toast("输入物流码不能为空!");
      }
    },
    onSubmit() {
      localStorage.setItem("codes", JSON.stringify(this.codeList));
      if (this.codeList.length != 0) {
        this.$router.push({
          name: "ScanPreview",
          params: {
            logistics: this.codeList,
          },
        });
      } else {
        this.$toast("请添加物流码!");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.account-setting {
  height: 100vh;
  overflow-y: hidden;
  .menu {
    margin-top: 0.5rem;
    height: 65%;
    overflow-y: scroll;
    .list {
      width: 80%;
      margin: 0 auto;
      height: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #d8d8d8;
    }
  }

  .add {
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 0.3rem;
  }
  .button {
    height: 35%;
    margin-top: 2rem;
  }
}
</style>
